import * as yup from "yup";

export const newDentistSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  dentalClinicId: yup.string().required("Dental Clinic is required"),
  dentalClinicName: yup.string().nullable(),
  dateOfBirth: yup
    .date()
    .typeError("Date of birth must be valid")
    .required("Date of birth"),
  dentistId: yup.string("Select a valid dentist").nullable(),
});
